import { forwardRef, useEffect, useState } from "react";
import PropTypes from "prop-types";
import Button, { BUTTON_VARIANTS, BUTTON_SIZES } from "app/pages/.shared/form/Button";
import classNames from "classnames";
import "./AnimatedWidthButton.scss";
import { ChevronDown } from "app/icons/navigation";
import useMeasure from "react-use-measure";

export const AnimatedWidthButton = forwardRef(
	(
		{
			className,
			isActive = false,
			isOpen = false,
			children,
			["data-testid"]: dataTestId,
			...props
		},
		ref
	) => {
		const [ghostRef, bounds] = useMeasure();
		const [enableTransition, setEnableTransition] = useState(false);

		useEffect(() => {
			if (!window.matchMedia) {
				return;
			}

			const shouldReduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)")
				.matches;

			if (!shouldReduceMotion) {
				setEnableTransition(true);
			}
		}, []);

		return (
			<Button
				size={BUTTON_SIZES.SMALL}
				variant={BUTTON_VARIANTS.STROKE}
				className={classNames("animated-width-button", className)}
				data-active={isActive}
				data-transition={enableTransition}
				ref={ref}
				style={{ width: bounds.width || undefined }}
				{...props}
			>
				<span className="animated-width-button__content-main" data-testid={dataTestId}>
					{children}
					<ChevronDown rotated={isOpen} size={15} />
				</span>

				<span
					className="animated-width-button__content-ghost"
					ref={ghostRef}
					aria-hidden="true"
				>
					<span className="animated-width-button__content-main">
						{children}
						<ChevronDown rotated={isOpen} size={15} />
					</span>
				</span>
			</Button>
		);
	}
);

AnimatedWidthButton.propTypes = {
	className: PropTypes.string,
	isActive: PropTypes.bool,
	isOpen: PropTypes.bool,
	children: PropTypes.node.isRequired,
};
